import { Code, Download, KeyRound, Plug, Users, Zap } from 'lucide-react'

export interface SetupStep {
  id: number
  title: string
  description: string
  instructions: string[]
  icon: React.ElementType
  tip?: string
  /** Step requires manual user confirmation (checkbox) */
  manual?: boolean
  /** Step has inline interactive content (form, dropdown, etc.) */
  hasInlineContent?: boolean
}

export const SETUP_STEPS: SetupStep[] = [
  {
    id: 1,
    title: 'Install the Plugin',
    description: 'Download the One Email plugin and install it on your WordPress site.',
    icon: Download,
    hasInlineContent: true,
    instructions: [
      'Download the plugin using the button below',
      'Go to your WordPress admin panel (yoursite.com/wp-admin)',
      'Click Plugins in the left sidebar, then Add New, then Upload Plugin',
      'Upload the one-email.zip file and click Install Now',
      'Click Activate Plugin when the install finishes',
    ],
  },
  {
    id: 2,
    title: 'Generate a Connection Token',
    description: 'Create a one-time token to link your WordPress site.',
    icon: KeyRound,
    instructions: [
      'Enter your site name below and click Generate Token',
      'Copy the token that appears — it expires in 10 minutes',
    ],
    tip: 'Keep this tab open. You will paste the token in WordPress in the next step.',
    hasInlineContent: true,
  },
  {
    id: 3,
    title: 'Connect in WordPress',
    description: 'Paste the token in your WordPress plugin settings.',
    icon: Plug,
    instructions: [
      'In your WordPress admin, go to Settings then One Email',
      'Paste the token in the Connection Token field',
      'Click the Connect button',
      'You should see a green "Connected to One Email" message',
    ],
  },
  {
    id: 4,
    title: 'Choose Your Audience',
    description: 'Select which email list should receive new subscribers.',
    icon: Users,
    instructions: [
      'Select your audience from the dropdown below',
      'This audience will receive new subscribers from your WordPress form',
    ],
    tip: 'No audience yet? Use the link below to create one first.',
    hasInlineContent: true,
  },
  {
    id: 5,
    title: 'Connect Your Subscribe Form',
    description: 'Point any form on your site to your One Email subscribe endpoint.',
    icon: Code,
    instructions: [
      'Copy your subscribe endpoint URL below',
      'Connect any form builder (Elementor, WPForms, Contact Form 7, custom HTML) to this endpoint',
      'Submit a test email to confirm subscribers appear in your audience',
    ],
    manual: true,
    hasInlineContent: true,
  },
  {
    id: 6,
    title: 'Test Your Connection',
    description: 'Verify the subscribe endpoint is working end-to-end.',
    icon: Zap,
    instructions: [],
  },
]

export const TOTAL_STEPS = SETUP_STEPS.length
